module.exports = __webpack_public_path__ + "img/account.fd7c5588.webp";